import { useCallback, useEffect, useState } from "react";

/**
 * Watch element size
 */
export const useWidth = (ref: React.RefObject<HTMLElement>, defaultWidth: number = 0) => {
    const [width, setWidth] = useState(defaultWidth);

    const updateSize = useCallback(() => {
        if(!ref.current || (ref.current.offsetWidth === width && !width)) return;
        setWidth(ref.current.offsetWidth);
    }, [setWidth])

    useEffect(() => {
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => {
            window.removeEventListener('resize', updateSize);
        };
    }, [updateSize])
    return {
        width,
    }
}